import ComparePage from '../components/ComparePage';
import { withConfig } from '../lib/withConfig';
async function getServerSidePropsFunction({ req, res, query: { tab } = {} }) {
    return {
        props: {}
    }
}
export const getServerSideProps = withConfig(getServerSidePropsFunction)
export default ComparePage;
